<template>
	<div class="content-finish">
		<div style="padding: 0px;" class="mask" v-bind:style="{backgroundColor : color_botones }">
			<img src="https://info.vinapp.co/wp-content/uploads/2021/05/estrellas.png" alt="">
			<div class="check">
				<i class="fas fa-check" v-bind:style="{color : color_botones }"></i>
			</div>
			<h4 class="title">¡Gracias!</h4>
			<h4 class="subtitle">Este es el resumen de tu pedido.</h4>
			<h4 class="subtitle" v-if="estado == 'PENDIENTE'">Procese el pago y en unos segundos le confirmaremos su pedido.</h4>

		</div>
		<div class="data-finish">
			<div class="content-order">
				<img v-if="qr_image_bancolombia != '' && estado == 'PENDIENTE'" class="img-width" :src="qr_image_bancolombia" />
				<h4>Estado: {{ estados.find(e => e.id == order_status).name }}</h4>
				<h4 v-if="wompi">Pago: {{ estado }}</h4>
			</div>
			<div class="data-finish-client">
				<div class="both-data-finish">
					<h4>Nombre:</h4>
					<h5>{{ order.name }}</h5>
				</div>
				<div class="both-data-finish">
					<h4>Teléfono:</h4>
					<h5>{{ order.phone }}</h5>
				</div>
			</div>
			<div class="order-finish-client">
				<div class="order-finish-detail">
					<div class="options">
						<h4>Detalle de orden</h4>
						<i class="fas fa-angle-down" @click="show()"></i>	
					</div>
					<div class="products-order">
						<li v-for="(item, index) in detail" :key="index">{{item.quantity}} {{item.name_product}}</li>
					</div>
				</div>
				<div class="finish-order-total">
					<h4>Total:</h4>
					<h5>${{ Intl.NumberFormat("de-DE").format( order.total) }}</h5>
				</div>
			</div>
		</div>
		<div v-if="wa_redirect=='true' && (kiosko == 'false' || kiosko == false)" class="container-button" @click="enviarWhatsApp()">
			<div class="send-button">
			  <i class="fab fa-whatsapp what"></i>
			  <label class="send-text">Ayuda con mi pedido</label>
			</div>
		</div>
		<div class="container-button" @click="Volver()">
	      <div class="send-button" v-bind:style="{backgroundColor : color_botones +'!important' }">
			<i class="fas fa-arrow-left"></i>
	        <label class="send-text">Volver a la tienda</label>
	      </div>
    	</div>
		
		
	</div>
</template>

<script>
	import axios from 'axios';
	import { printUSB } from "./util/print-web.js";
	export default{
		data(){
			return{
				selectedDevice: null,
				socketUnified: false,
				portPrint: 3000,
				socketPrint: "",
				color_botones: localStorage.getItem('color_licencia'),
				telefono_pedidos: localStorage.getItem('telefono_pedidos'),
				form:{
					id_order:0
				},
				sound: false,
				contador:0,
				total_cart:0,
				order:[],
				detail:[],
				wompi:null,
				order_status:1,
				company:[],
				status:[],
				estado: "PENDIENTE",
				validarTexto: "Validar mi pago exitoso",
				wa_redirect: localStorage.getItem('wa_redirect'),
				estados: [{id:0,name:'Cancelada'},{id:7,name:'Cortesia'},{id:1,name:'Creada'},{id:4,name:'Entregada'},{id:5,name:'Confirmada'}],
				qr_image_bancolombia: '',
				kiosko: localStorage.getItem('kiosko'),
				is_print: false,
			}
		},
		methods:{
			async loadPrinter() {
				const printerData = localStorage.getItem('selectedPrinter');
				if (printerData) {
					const { vendorId, productId } = JSON.parse(printerData);

					try {
					const devices = await navigator.usb.getDevices();
					const matchedDevice = devices.find(
						(device) =>
						device.vendorId === vendorId && device.productId === productId
					);

					if (matchedDevice) {
						this.selectedDevice = matchedDevice;
						console.log('Impresora cargada con éxito');
					} else {
						console.log('Impresora no encontrada');
					}
					} catch (error) {
					console.log(error.message);
					console.log('Error al cargar la impresora');
					}
				} else {
					console.log('No hay impresora cargada');
				}
			},
			reload(){
				location.reload();
			},
			setupOrder() {
				this.form.id_order=this.$route.params.id_order;
				axios.post('https://back.vinapp.co/api/company/getDataOrder',this.form)
					.then(res => {          
          				if(res.data.error == false){
							if(localStorage.getItem('qr_image_bancolombia') != ''){
								this.kiosko = 'true';
								localStorage.setItem('kiosko', 'true');
								this.qr_image_bancolombia = localStorage.getItem('qr_image_bancolombia')
							}
          					this.order=res.data.order;
							this.order_status=res.data.order.status;
          					this.detail=res.data.detail;
          					this.company=res.data.company;
          					this.store=res.data.store;
          					this.wompi=res.data.wompi;
          					if(res.data.wompi)this.estado = res.data.wompi.estado_actual;
							if((this.estado == 'Confirmada' || this.estado == 'CONFIRMADA' || this.estado == 'APROBADA' || this.estado == 'Aprobada') && this.kiosko == 'true' && !this.is_print)this.saveDocument();
							
          				}
          			})
          			.catch(err => {
            			console.log(err);      
        			});
			},
			show(){
				if (this.contador == 0) {
					$(".products-order").addClass('height');
					$(".fa-angle-down").removeClass('rotate');
					this.contador++;	
				}else{
					$(".products-order").removeClass('height');
					$(".fa-angle-down").addClass('rotate');
					this.contador = 0;
				}
				
			},
			Volver() { //Por si acaso
				const url = `${location.origin}/${this.$route.params.id}`;
				location.href = this.kiosko == 'true' || this.kiosko == true ? `${url}?kiosko` : url;
			},
			enviarWhatsApp(){  
		      //construimos el mensaje para wapp
		      //se agregan los espacios al nombre de la empresa      
		      this.mensaje = '';
		      //let comentario = this.order.commentary;
		      let nombre_comercial = this.company.name;
		      nombre_comercial = nombre_comercial.replace(" ","%20");
		      let nombre = this.order.name;
		      let telefono = this.order.phone;
		      nombre = nombre.replace(" ","%20");     
		      var txtOrder ="Orden "+this.order.id_order+" "; 
		      var value = 0;
		      var reemplazar="";
		      var barrio_u="";
		      if (this.nameOS =='iOS') {
		          this.mensaje += `
		          whatsapp://send?phone=${this.telefono_pedidos}&text=${txtOrder}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
		      }else{
		        this.mensaje += `
		         https://wa.me/${this.telefono_pedidos}?text=${txtOrder}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
		      } 
		      this.mensaje += '%0A%0A';  
		      this.mensaje += `*Dirección:*%20${encodeURIComponent(this.order.address)}`;        
		      this.mensaje += '%0A';//un espacio  
		      this.mensaje += '*Celular:*%20'+this.order.phone;
		      this.mensaje += '%0A%0A';
		      /*this.mensaje += `*Numero de orden:*%20${this.order.id_order}`;
		      this.mensaje += '%0A';*/
		      this.mensaje += '*Detalle de la orden:*';
		      this.mensaje += '%0A';
		      this.detail.forEach((detail)=>{
		        value = 0;
		        this.mensaje += `-%20${detail.quantity}%20x%20${detail.name_product}`;
		        reemplazar = detail.name_product;
		        //reemplazar = reemplazar.replace(" ","%20");
		        reemplazar = encodeURIComponent(reemplazar);
		        this.mensaje += '.%0A%0A';
		      });
		      //definimos la forma de pago.
		      this.mensaje += `*Total%3A*%20${new Intl.NumberFormat("de-DE").format(this.order.total)}`;
		      this.mensaje += '%0A%0A';

			  if(this.wompi){
		        this.mensaje += `*Pago en Wompi*`; 
		        this.mensaje += '%0A';
		        this.mensaje += `*Id de la transacción%3A*%20${this.wompi.id_transaccion}`;
		        this.mensaje += '%0A%0A';
			  }
		        if(this.order.commentary == null){
		        	this.mensaje += `*Comentario%3A*%20`;
		        } else {
		        	this.mensaje += `*Comentario%3A*%20${this.order.commentary}`;
		        }
		      
		      this.mensaje += '%0A%0A';
		      this.mensaje += `Gracias.`; 

		      setTimeout(function() { 
		              $(".button-loading").addClass("send-button");
		              $(".send-button").removeClass("button-loading");
		              $(".send-text").removeClass("hide");
		              $(".what").removeClass("hide");
		              $(".fa-check").addClass("hide");

		      }, 4000); 
		      //location.href = this.mensaje;
			  window.open(this.mensaje,'_blank'); 
		    },
			saveDocument(){
				let self = this
				var data = {};

				data.id_companie = localStorage.getItem('id_company');
				data.id_order = this.form.id_order;
				if(localStorage.getItem('id_cash_movement'))data.id_cash_movement = localStorage.getItem('id_cash_movement');
				if(this.socketPrint == ""){
					this.socketPrint = io(`https://back.vinapp.co:${this.portPrint}`,{transports: ['websocket'], upgrade: false});
				}
				axios.post('https://back.vinapp.co/api/save-documents',data)
					.then(res=>{
						if(res.data.statusCode == 200){
							if(this.kiosko == 'true'){
								self.printBySocket(this.form.id_order, false, true);
							}
						}else{
							console.log('error al confirmar la orden')
						}
					}).catch(err=>{
						console.log({error : err})
					});
			},
			printBySocket(id_order, comanda = false, kiosko = false){
				var self = this;
				let url = 'https://back.vinapp.co/api/socket-order/getDataPrintOrder/'+id_order;
				if (comanda == true) url += '/true';
				axios.get(url)
				.then(res => {
					if(res.data.error == false){
						if(kiosko){
							if (this.selectedDevice && !this.is_print) {
								var data = res.data.data;
								data.type_print = 'comanda';
								this.socketPrint.emit('new print', res.data.data);
								printUSB(res.data.data);
								this.is_print = true;
								//this.paginaDePrueba(res.data.data);
							}else{
								this.socketPrint.emit('new print', res.data.data);
							}
							setTimeout(() => {
								this.Volver();
							}, 3000);
							//this.printImin(res.data.data);
							
						}else if (res.data.data.type_print != "unidades"){
							if(!this.socketUnified){
							//console.log('imprimiendo');
							this.socketPrint.emit('new print', res.data.data);
							}else{
							this.socketTable.emit('new print', res.data.data);
							}
						}
					}else{
					console.log('Ocurrio el siguiente error al intentar imprimir: '+res.data.message);
					}

				})
				.catch(err => {
					console.log(err)
				});  

			},
			async paginaDePrueba(data) {
				if (data.bebidas.length > 0) {
					data.bebidas.forEach(item => {
					data.details.push(item);
					});
				}

				const ejemploDatos = {
					header: {
					title: 'PAGINA DE PRUEBA',
					company: `${this.license.name}`,
					nit: data.nit_business || 'No definido',
					city: data.city_point || 'VALLEDUPAR',
					phone: this.license.phone || 'No definido',
					address: this.license.address || 'No definido',
					resolution: data.resolution || 'No definida',
					prefix: 'HABILITADA DESDE 1 AL 10000 CON PREFIJO: CO'
					},
					orderNumber: data.document_number || 'No definido',
					date: data.document_date || 'No definida',
					seller: data.vendedor || 'No definido',
					customerName: data.client_name || 'No definido',
					customerNit: data.client_identification || 'No definido',
					customerAddress: data.client_address || 'No definido',
					items: [],
					service: data.service,
					shipping: data.shipping,
					subtotal: data.subtotal,
					total_discount: data.total_discount,
					tax: data.impuesto_consumo == null ? 0 : parseFloat(data.impuesto_consumo.replace('$', '').replace(',', '').trim()),
					subtotalWithTax: data.subtotal_without_imp,
					paymentMethod: data.payment_methods || 'Efectivo',
					total: data.total,
					cufe: data.tascode || 'No disponible'
				};

				// Reemplazamos el map con un ciclo for      
				for (const detail of data.details) {
					ejemploDatos.items.push({
					description: detail.product_invoice || 'Producto no disponible',
					price: detail.value,
					quantity: detail.quantity || 1
					});
				}

				this.preview = this.formatearTicket(ejemploDatos);

				try {
					await this.selectedDevice.open();
					await this.selectedDevice.selectConfiguration(1);
					await this.selectedDevice.claimInterface(0);

					const commands = new Uint8Array([
					0x1b, 0x40,
					0x1b, 0x61, 0x00,
					...new TextEncoder().encode(this.preview),
					0x0a, 0x0a, 0x0a,
					0x1d, 0x56, 0x41, 0,
					]);

					await this.selectedDevice.transferOut(1, commands);
					this.updateStatus('status', 'Página de prueba enviada correctamente');
				} catch (error) {
					console.log(error.message);
					this.updateStatus('status', 'Ocurrió un error al imprimir', true);
				}
				},
				formatearTicket(datos) {
				const linea = '-'.repeat(45) + '\n';
				const anchoMax = 45;
				let ticket = '';

				// Encabezado centrado
				const encabezado = [
					datos.header.title,
					datos.header.company,
					`Nit: ${datos.header.nit}`,
					`Ciudad: ${datos.header.city}`,
					`Telefono: ${datos.header.phone}`,
					`Direccion: ${datos.header.address}`,
					datos.header.resolution,
					datos.header.prefix
				].join('\n');

				ticket += this.centrarTexto(encabezado, anchoMax) + '\n';
				ticket += linea;

				const detalleFactura = [
					`Factura Electronica de Venta: ${datos.orderNumber}`,
					`Fecha: ${datos.date}`,
					`Vendedor: ${datos.seller}`,
					`Nombre: ${datos.customerName}`,
					`Nit: ${datos.customerNit}`,
					`Direccion: ${datos.customerAddress}`,
				];

				detalleFactura.forEach(lineaDetalle => {
					ticket += lineaDetalle + '\n'; // Alinear a la derecha usando el ancho máximo
				});

				ticket += linea;

				// Productos (formato de columnas fijas)
				ticket += 'Descripcion               Cant       Valor\n';
				datos.items.forEach(item => {
					const descripcion = item.description.substring(0, 20).padEnd(20);
					const cantidad = item.quantity.toString().padStart(10);
					const valor = item.price.padStart(15);
					ticket += `${descripcion}${cantidad}${valor}\n`;
				});
				ticket += linea;

				// Totales alineados a la derecha
				const totales = [
					`Subtotal: ${datos.subtotalWithTax}`,
					`Imp. Consumo: ${datos.tax}`,
					`Propina: ${datos.service}`,
					`Domicilio: ${datos.shipping}`,
					`Descuento: ${datos.total_discount}`,
					`Total: ${datos.total}`,
					`Forma de pago: ${datos.paymentMethod}`,
					//`Subtotal sin Imp: ${datos.subtotal}`,
					
				];

				totales.forEach(lineaTotal => {
					ticket += lineaTotal.padStart(anchoMax) + '\n'; // Alinear a la derecha
				});

				ticket += linea;

				// Pie de página
				const pieDePagina = [
					'Qr para descargar su factura.',
					`No. Factura Electronica: ${datos.orderNumber}`,
					`Cufe: ${datos.cufe}`,
					'',
					'¡Gracias por su compra!',
					'Impreso por VinApp'
				];

				// Aplicar centrado a cada línea del pie de página
				const pieDePaginaCentrado = this.centrarTexto(pieDePagina.join('\n'), anchoMax);
				ticket += pieDePaginaCentrado;

				return ticket;
				},
				centrarTexto(texto, ancho) {
				const partes = texto.split('\n'); // Dividir en líneas
				return partes.map(linea =>
					linea
					.padStart(linea.length + Math.floor((ancho - linea.length) / 2), ' ') // Centrar
					.padEnd(ancho, ' ') // Asegurar ancho total
				).join('\n');
				},
			printImin(data) {
				var IminPrintInstance = new IminPrinter();
				IminPrintInstance.connect().then(async (isConnect) => {
					if (isConnect) {

						//FACTURA
						IminPrintInstance.setAlignment(1);
						IminPrintInstance.printSingleBitmap(`${data.logo_company_print}`)
						IminPrintInstance.printText(`${data.business}`);
						IminPrintInstance.printText(`${data.nit_business}`);
						IminPrintInstance.printText(data.city_point);
						IminPrintInstance.printText(data.phone_point);
						IminPrintInstance.printText(data.address_point);
						IminPrintInstance.printText('');
						
						IminPrintInstance.setAlignment(0);
						if(data.document_number.includes('FE')){
							IminPrintInstance.printText(`Estado de Cuenta: ${data.document_number}`);
						}else{
							IminPrintInstance.printText(`Factura Venta Nº: ${data.document_number}`);
						}
						IminPrintInstance.printText(`Fecha: ${data.document_date}`);
						if(data.mesero != null){
							IminPrintInstance.printText(`Mesero: ${data.mesero}`);
						}

						IminPrintInstance.printText(`Nombre: ${data.client_name}`);
						if(data.client_identification == null){
							if(data.nit != null)IminPrintInstance.printText(`Cédula: ${data.nit}`);
						}else{
							IminPrintInstance.printText(`Cédula: ${data.client_identification}`);
						}
						
						IminPrintInstance.printText(`Teléfono: ${data.client_phone}`);
						//IminPrintInstance.printText(`Dirección: ${data.client_address}`);
						if(data.table>0)IminPrintInstance.printText(`Mesa: ${data.table}`);

						
						IminPrintInstance.printColumnsText(["Descripción", "Cant", "Valor"], [318, 129, 129], [0, 0, 2], [28, 28, 28], 576);

						data.details.forEach(item => {
							IminPrintInstance.printColumnsText([item.product_invoice, item.quantity, item.value], [318, 129, 129], [0, 0, 2], [28, 28, 28], 576);
						});
						
						IminPrintInstance.printColumnsText(["Subtotal:", data.subtotal], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Domicilio:", data.shipping], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Descuento:", data.total_discount], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Servicio Voluntario:", data.service], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Impuesto de consumo:", data.impuesto_consumo], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Forma de pago:", data.payment_methods], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.printColumnsText(["Total:", data.total], [346, 230], [2, 2], [28, 28], 576);
						IminPrintInstance.setAlignment(1);
						IminPrintInstance.printText('');

						IminPrintInstance.printText(`${data.text_final}`);
						if (data.qr_fac) {
							IminPrintInstance.printQrCode('https://admin.vinapp.co/fe-vinapp/'+data.id_order, 1); 
						}
						IminPrintInstance.printText('¡Gracias por su compra!');
						IminPrintInstance.printText('NIT. 901504327');
						IminPrintInstance.printText('Impreso por Vinapp');
						IminPrintInstance.printAndFeedPaper(100);
						IminPrintInstance.partialCut();

						//location.reload();
						//FIN FACTURA
					}
				});
				//location.reload();
				/*.catch((error) => {
					alert('error al imprimir');
						console.error("Error al intentar conectar con la impresora imin:", error);
						location.reload(); // Recargar si ocurre un error de conexión
					});*/
		},
		},
		mounted(){
			this.is_print = false;
			this.loadPrinter();
			this.setupOrder();
			this.contador = 0;
			
			setInterval(() => {
				this.setupOrder();
			}, 30000);
		}
	}

</script>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
	.content-finish{
		width: 100%;
		height: auto;
	}
	.img-width{
		width: 60%;
	}
	.mask{
		width: 100%;
		height: 50vh;
		/*border-bottom-left-radius: 120px;
		border-bottom-right-radius: 120px;*/
	}
	.mask img{
		width: 50%;
		animation: scala .7s ease-in-out;
	}
	.check{
		width: 62px;
		height: 62px;
		border-radius: 50%;
		background: #fff;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.check i{
		font-size: 26px;
	}
	.title{
		padding-top: 35px;
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #fff;
		margin-bottom: 4px;
	}
	.subtitle{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 10px 10px 5px 10px;
	}
	.subtitle2{
		font-size: 17px;
		font-family: Poppins, sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 0px;
	}
	.data-finish{
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 8px 10px 0px rgba(215,215,215,1);
		margin-top:-75px;
	}
	.content-order{
		border-bottom: 1px solid #f2f2f2;
		padding-top: 25px;
		padding-bottom: 10px;
	}
	.content-order h4{
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #000;
		margin-bottom: 4px;
	}
	.content-order h5{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
		margin-bottom: 2px;
	}
	.data-finish-client{
		width: 100%;
		height: auto;
		padding: 5px 0px;
		border-bottom: 1px solid #f2f2f2;
	}
	.both-data-finish{
		width: 100%;
		height: auto;
		padding: 5px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.both-data-finish h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.both-data-finish h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.finish-order-total{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.order-finish-detail{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		border-bottom: 1px solid #f2f2f2;
		transition: all .3s ease-in-out;
	}
	.options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.products-order{
		width: 100%;
		text-align: left;
		padding-left: 15px;
		padding-top: 10px;
		transition: all 3s ease-in-out;
	}
	.products-order li{
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}
	.order-finish-detail h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
		margin-bottom: 0;
	}
	.order-finish-detail i{
		margin-right: 5px;
		cursor: pointer;
	}
	.cart-finish-detail{
		width: 100%;
	}
	.height{
		height: 0px !important;
		overflow: hidden;
	}
	.finish-order-total h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.finish-order-total h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.button-back-to-home button{
		padding: 10px 25px;
		background:transparent;
		font-size: 17px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		border-radius: 5px;
	}
	.button-back-to-home button:focus{
		outline: none !important;
	}
	.button-back-to-home i{
		margin-right: 8px;
	}
	.rotate{
		transform: rotate(180deg);
	}
	@keyframes scala {
		from{
			transform: scale(0);
		}
		to{
			transform: scale(1);
		}
	}
	.container-button{
      width: 95%;
      padding: 10px 0px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
    .send-button{
      width: 100%;
      background: #64B161;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button i:nth-child(1){
		color: #fff;
		margin-right: 6px;
    }
</style>